import { Fragment } from 'react';
import { Typography } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import Button from 'components/new-ui/base/button/Button';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { PostMirrorField } from './postMirrorFields';
import { StyledContent, StyledFields } from './styles';

type Props = {
    open: boolean;
    fields: PostMirrorField[];
    sourceMessageType: MessageTypes;
    isSaving: boolean;
    canSave: boolean;
    onSave: () => void;
    onDismiss: () => void;
    onClose: () => void;
};

// Offers the master level fields a mirrored declaration could not inherit
// from its source as the structure is different. The fields are the form's own,
// so whatever is entered here is entered on the declaration itself.
const PostMirrorCompletionModal = ({
    open,
    fields,
    sourceMessageType,
    isSaving,
    canSave,
    onSave,
    onDismiss,
    onClose,
}: Props) => (
    <ConfirmationModal
        open={open}
        title="Complete Fields"
        icon={<FileTextOutlined />}
        confirmButtonText="Save and Continue"
        confirmationButtonDisabled={!canSave}
        confirmationButtonLoading={isSaving}
        onConfirm={onSave}
        onClose={onClose}
        maskClosable={false}
        footerLeft={<Button onClick={onDismiss}>Dismiss and Complete on the Form</Button>}
        content={
            <StyledContent>
                <Typography.Text>
                    These fields can not be derived from the {sourceMessageType} declaration. You can quickly fill them
                    here, or inside the form.
                </Typography.Text>
                <StyledFields>
                    {fields.map(({ path, render }) => (
                        <Fragment key={path}>{render()}</Fragment>
                    ))}
                </StyledFields>
            </StyledContent>
        }
    />
);

export default PostMirrorCompletionModal;
